"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.attachMouseInput = exports.attachKeyInput = void 0;
const InputEmitter_1 = require("./InputEmitter");
const debounce_1 = require("debounce");
// Returns true if the given key is reserved for the browser
const isReservedKey = (reservedKeys, key) => {
    return reservedKeys.includes(key);
};
exports.attachKeyInput = (reservedKeys, emitter) => {
    // Prevent focus on buttons after clicking.
    document.addEventListener('click', () => {
        if (document.activeElement.toString() === '[object HTMLButtonElement]') {
            if (document.activeElement instanceof HTMLElement) {
                document.activeElement.blur();
            }
        }
    });
    document.onkeydown = (e) => {
        if (isReservedKey(reservedKeys, e.key)) {
            return;
        }
        if (emitter === null) {
            return;
        }
        emitter.EmitKeyDown(e);
        if (emitter.IsBrowserKey(e)) {
            e.preventDefault();
        }
    };
    document.onkeyup = (e) => {
        if (isReservedKey(reservedKeys, e.key)) {
            return;
        }
        if (emitter === null) {
            return;
        }
        emitter.EmitKeyUp(e);
        if (emitter.IsBrowserKey(e)) {
            e.preventDefault();
        }
    };
    document.onkeypress = (e) => {
        if (isReservedKey(reservedKeys, e.key)) {
            return;
        }
        if (emitter === null) {
            return;
        }
        emitter.EmitKeyPress(e.charCode);
    };
};
exports.attachMouseInput = (videoRef, emitter, useNativeTouchEvents = false, usePointerLock, pointerLockRelease) => {
    let lastX = -1;
    let lastY = -1;
    let unlock = false;
    if (videoRef) {
        videoRef.onmouseenter = (e) => {
            if (videoRef === null || emitter == null) {
                return;
            }
            emitter.EmitMouseEnter();
            e.preventDefault();
        };
        videoRef.onmouseleave = (e) => {
            if (videoRef === null || emitter == null) {
                return;
            }
            const viewPortHeight = videoRef.clientHeight;
            const viewPortWidth = videoRef.clientWidth;
            const streamHeight = videoRef.videoHeight;
            const streamWidth = videoRef.videoWidth;
            /*
             * Handles when a mouse button is pressed down when the mouse leaves the videoRef. This will handle simultaneously pressed
             * Example: if the secondary (2) and auxilary (4) buttons are pressed simultaneously, the value is 6 (2 + 4).
             */
            if (e.buttons === InputEmitter_1.MouseButtonsState.PrimaryButton) {
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.MainButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            else if (e.buttons === InputEmitter_1.MouseButtonsState.SecondaryButton) {
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.SecondaryButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            else if (e.buttons === InputEmitter_1.MouseButtonsState.PrimarySecondaryButton) {
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.MainButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.SecondaryButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            else if (e.buttons === InputEmitter_1.MouseButtonsState.AuxiliaryButton) {
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.AuxiliaryButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            else if (e.buttons === InputEmitter_1.MouseButtonsState.PrimaryAuxilaryButton) {
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.MainButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.AuxiliaryButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            else if (e.buttons === InputEmitter_1.MouseButtonsState.SecondaryAuxilaryButton) {
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.AuxiliaryButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.SecondaryButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            else if (e.buttons === InputEmitter_1.MouseButtonsState.FourthButton) {
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.FourthButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            else {
                emitter.EmitMouseUp(InputEmitter_1.MouseButton.FifthButton, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            emitter.EmitMouseLeave();
            e.preventDefault();
        };
        videoRef.onmousedown = (e) => {
            if (videoRef === null || emitter === null) {
                return;
            }
            const viewPortHeight = videoRef.clientHeight;
            const viewPortWidth = videoRef.clientWidth;
            const streamHeight = videoRef.videoHeight;
            const streamWidth = videoRef.videoWidth;
            pointerLockDebounce(e);
            if (document.pointerLockElement === videoRef) {
                emitter.EmitMouseDown(e.button, lastX, lastY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            else {
                emitter.EmitMouseDown(e.button, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
        };
        function setPointerLock(e) {
            if (!document.pointerLockElement && usePointerLock) {
                videoRef.requestPointerLock();
                lastX = e.x;
                lastY = e.y;
                unlock = true;
            }
            else {
                unlock = false;
            }
        }
        const pointerLockDebounce = debounce_1.debounce(setPointerLock, 200);
        videoRef.onmouseup = (e) => {
            if (videoRef === null || emitter === null) {
                return;
            }
            const viewPortHeight = videoRef.clientHeight;
            const viewPortWidth = videoRef.clientWidth;
            const streamHeight = videoRef.videoHeight;
            const streamWidth = videoRef.videoWidth;
            if (usePointerLock && pointerLockRelease) {
                pointerLockDebounce.clear();
            }
            if (document.pointerLockElement === videoRef && usePointerLock) {
                emitter.EmitMouseUp(e.button, lastX, lastY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            else {
                emitter.EmitMouseUp(e.button, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            if (unlock && pointerLockRelease) {
                document.exitPointerLock();
            }
            e.preventDefault();
        };
        videoRef.onmousemove = (e) => {
            if (videoRef === null || emitter === null) {
                return;
            }
            const viewPortHeight = videoRef.clientHeight;
            const viewPortWidth = videoRef.clientWidth;
            const streamHeight = videoRef.videoHeight;
            const streamWidth = videoRef.videoWidth;
            if (document.pointerLockElement === videoRef && usePointerLock) {
                if (lastX < 0) {
                    lastX = viewPortWidth / 2;
                }
                if (lastY < 0) {
                    lastY = viewPortHeight / 2;
                }
                let x = lastX + e.movementX;
                let y = lastY + e.movementY;
                if (x > viewPortWidth) {
                    x -= viewPortWidth;
                }
                if (y > viewPortHeight) {
                    y -= viewPortHeight;
                }
                if (x < 0) {
                    x = x + viewPortWidth;
                }
                if (y < 0) {
                    y = viewPortHeight - y;
                }
                emitter.EmitMouseMove(x, y, e.movementX, e.movementY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
                lastX = x;
                lastY = y;
            }
            else {
                emitter.EmitMouseMove(e.offsetX, e.offsetY, e.movementX, e.movementY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            e.preventDefault();
        };
        videoRef.oncontextmenu = (e) => {
            if (videoRef === null || emitter === null) {
                return;
            }
            e.preventDefault();
        };
        videoRef.onwheel = (e) => {
            if (videoRef === null || emitter === null) {
                return;
            }
            const viewPortHeight = videoRef.clientHeight;
            const viewPortWidth = videoRef.clientWidth;
            const streamHeight = videoRef.videoHeight;
            const streamWidth = videoRef.videoWidth;
            emitter.EmitMouseWheel(e.deltaY, e.offsetX, e.offsetY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
        };
        videoRef.ontouchend = (e) => {
            if (videoRef === null || emitter === null) {
                return;
            }
            if (useNativeTouchEvents) {
                emitter.EmitTouchData(InputEmitter_1.MessageType.TouchEnd, e.changedTouches, videoRef.offsetLeft, videoRef.offsetTop, videoRef.clientHeight, videoRef.clientWidth, videoRef.videoHeight, videoRef.videoWidth);
            }
            else {
                const viewPortHeight = videoRef.clientHeight;
                const viewPortWidth = videoRef.clientWidth;
                const streamHeight = videoRef.videoHeight;
                const streamWidth = videoRef.videoWidth;
                const x = e.changedTouches[0].clientX - videoRef.offsetLeft;
                const y = e.changedTouches[0].clientY - videoRef.offsetTop;
                emitter.EmitMouseUp(0, x, y, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
            }
            e.preventDefault();
        };
        videoRef.ontouchmove = (e) => {
            if (videoRef === null || emitter === null) {
                return;
            }
            if (useNativeTouchEvents) {
                emitter.EmitTouchData(InputEmitter_1.MessageType.TouchMove, e.changedTouches, videoRef.offsetLeft, videoRef.offsetTop, videoRef.clientHeight, videoRef.clientWidth, videoRef.videoHeight, videoRef.videoWidth);
            }
            else {
                if (lastX < 0) {
                    lastX = 0;
                }
                if (lastY < 0) {
                    lastY = 0;
                }
                const viewPortHeight = videoRef.clientHeight;
                const viewPortWidth = videoRef.clientWidth;
                const streamHeight = videoRef.videoHeight;
                const streamWidth = videoRef.videoWidth;
                const x = e.changedTouches[0].clientX - videoRef.offsetLeft;
                const y = e.changedTouches[0].clientY - videoRef.offsetTop;
                const deltaX = x - lastX;
                const deltaY = y - lastY;
                emitter.EmitMouseMove(x, y, deltaX, deltaY, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
                lastX = x;
                lastY = y;
            }
            e.preventDefault();
        };
        videoRef.ontouchstart = (e) => {
            if (videoRef === null || emitter === null) {
                return;
            }
            if (useNativeTouchEvents) {
                emitter.EmitTouchData(InputEmitter_1.MessageType.TouchStart, e.changedTouches, videoRef.offsetLeft, videoRef.offsetTop, videoRef.clientHeight, videoRef.clientWidth, videoRef.videoHeight, videoRef.videoWidth);
            }
            else {
                const viewPortHeight = videoRef.clientHeight;
                const viewPortWidth = videoRef.clientWidth;
                const streamHeight = videoRef.videoHeight;
                const streamWidth = videoRef.videoWidth;
                const x = e.changedTouches[0].clientX - videoRef.offsetLeft;
                const y = e.changedTouches[0].clientY - videoRef.offsetTop;
                emitter.EmitMouseMove(x, y, 10, 10, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
                emitter.EmitMouseDown(0, x, y, viewPortHeight, viewPortWidth, streamHeight, streamWidth);
                lastX = x;
                lastY = y;
            }
            e.preventDefault();
        };
    }
};
//# sourceMappingURL=InputHandlers.js.map